<ion-header collapse="fade" class="extendido" *ngIf="loaded">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Anotações' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content *ngIf="!loaded">
  <app-loading-spinner></app-loading-spinner>
</ion-content>

<ion-content *ngIf="loaded">
  <div class="gradient-extendido"></div>

  <ion-card-content *ngFor="let anotacao of anotacoes">
    <ion-card>
      <ion-grid>
        <ion-row class="ion-padding-top">
          <ion-col size="10" class="ion-padding-start d-flex">
            <ion-card-title>{{anotacao.entidade}} </ion-card-title>
          </ion-col>
          <ion-col size="2" (click)="editAnotacao(anotacao)" *ngIf="!userProvider.hasConfig(156)" class="d-flex ion-justify-content-center">
            <i class="fa-solid fa-arrow-right"></i>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="12" class="ion-padding-start">
            <p style="margin: 0.5rem 0">{{anotacao.anotacao}}</p>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="10" class="ion-padding-start d-flex">
            <p class="created">{{anotacao.created_at | dateFormat:"media"}}</p>
          </ion-col>
          <ion-col size="2" class="d-flex ion-justify-content-center">
            <i (click)="share(anotacao)" class="fa-solid fa-share-nodes"></i>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-card>
  </ion-card-content>
  <sem-registro [text]="'Nenhuma anotação encontrada'" [hidden]="anotacoes"></sem-registro>
</ion-content>
